(function() {
  
  zfrespond.views.CampaignOptOutView = Backbone.View.extend({
    
    className: 'opt-out',
    
    template: ZFRESPOND_JST.optout,
    
    events: {
      'click .action-opt-out': 'handleOptOut'
    },
    
    initialize: function(options) {
      this.campaign = options.contactCampaign;
      this.mediaCollectorUrlId = options.mediaCollectorUrlId;
      this.optedOut = false;
    }, 
    
    render: function() {
      this.$el.html(this.template({
        view: this
      }));
      if(this.optedOut) {
        this.$el.addClass('opted-out'); 
      }
      return this; 
    }, 
    
    handleOptOut: function(e) {
      var me = this; 
      this.campaign.save({
        opted_out: true
      }, {patch: true}).done(function() {
        me.optedOut = true; 
        me.render(); 
      }).fail(function(xhr) {
        alert("An unexpected error has occured, an engineer is being summoned now.");
      }); 
    }
    
  });
  
}());